import React, { useContext, createContext, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
  useNavigate
} from "react-router-dom";
import './App.css';

import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';
import { store, persistedStore } from './store.js';

import { ToastContainer } from 'react-toastify';
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";

import Main from './Main'
import Auth from './auth'
import Container from './home/container'
import Dashboard from './dashboard'
import Logout from "./auth/logout";

const MainRoutes = ({ }) => {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/login" element={<Auth />} />
      <Route path="/home" element={<Container />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/logout" element={<Logout />} />
    </Routes>
  )
}

export default function AuthExample({ }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistedStore}>
        <Router>
          <MainRoutes />
          <ToastContainer />
        </Router>
      </PersistGate>
    </Provider>
  );
}